import {
    BulletinHoursListIdsRequest
} from '../../../../../../../infrastructure/remote/sacmi/dto/request/BulletinHoursListIdsRequest';
import {
    SummaryListExportExcelRequest
} from '../../../../../../../infrastructure/remote/sacmi/dto/request/SummaryListExportExcelRequest';

const ExportSummaryListExcelDataMapper = {
    fromDomain(filters: BulletinHoursListIdsRequest): SummaryListExportExcelRequest {
        return {
            criteria: {
                term: filters.criteria.term,
                user_id: filters.criteria.user_id,
                start_date: filters.criteria.start_date,
                end_date: filters.criteria.end_date,
                bulletin_id: filters.criteria.bulletin_id,
                client_id: filters.criteria.client_id,
            }
        };
    }
}

export default ExportSummaryListExcelDataMapper;
